<script setup lang="ts">
    import {
        useHipSpineXRayImageControlsViewModel,
        BRIGHTNESS_MIN,
        BRIGHTNESS_MAX,
        CONTRAST_MIN,
        CONTRAST_MAX,
        ZOOM_MIN,
        ZOOM_MAX,
        XRAY_CONTROL_STEP,
    } from '@/views/3d-planner/hipSpine/xrayModal/useHipSpineXRayImageControlsViewModel';

    type ControlKey = 'contrast' | 'brightness' | 'zoom';

    /** One row of the controls strip: the VM value it drives, its label, and its slider bounds. */
    type SliderConfig = {
        key: ControlKey;
        label: string;
        min: number;
        max: number;
    };

    const controls = useHipSpineXRayImageControlsViewModel();

    const sliders: SliderConfig[] = [
        {
            key: 'contrast',
            label: 'Contrast',
            min: CONTRAST_MIN,
            max: CONTRAST_MAX,
        },
        {
            key: 'brightness',
            label: 'Brightness',
            min: BRIGHTNESS_MIN,
            max: BRIGHTNESS_MAX,
        },
        {
            key: 'zoom',
            label: 'Zoom',
            min: ZOOM_MIN,
            max: ZOOM_MAX,
        },
    ];
</script>

<template>
    <div class="image-controls">
        <div v-for="slider in sliders" :key="slider.key" class="image-control">
            <v-slider
                v-model="controls[slider.key]"
                :min="slider.min"
                :max="slider.max"
                :step="XRAY_CONTROL_STEP"
                :disabled="controls.isControlsDisabled"
                thumb-color="primary"
                track-color="secondary"
                track-fill-color="primary"
                :thumb-size="12"
                :track-size="2"
                density="compact"
                hide-details
            />
            <span class="image-control-label">{{ slider.label }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .image-controls {
        flex: 0 0 auto;
        z-index: 2;
        display: flex;
        flex-direction: row;
        gap: 16px;
        background-color: rgba(var(--v-theme-scene-background));
        padding: 8px 24px 12px;
        border-radius: 0 0 8px 8px;
    }

    .image-control {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: stretch;

        &-label {
            font-size: 13px;
            text-align: center;
            color: rgba(var(--v-theme-background));
        }
    }
</style>
